import styled from 'styled-components';

export const ShadowWidget = styled.div`
  box-shadow: 0px 16px 16px rgba(9, 12, 22, 0.5);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
`
